import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { uploadInjectionKey as W } from "./interface.js";
import Y from "./styles/index.cssr.js";
import { uploadDraggerKey as Z } from "./UploadDragger.js";
import ee from "./UploadFileList.js";
import te from "./UploadTrigger.js";
import { createSettledFileInfo as U, environmentSupportFile as ne, isImageFile as oe, matchType as re, createImageDataUrl as ie } from "./utils.js";
import { throwError as ae, warn as le } from "../../_utils/naive/warn.js";
import se from "../../_mixins/use-config.js";
import X from "../../_mixins/use-theme.js";
import de from "../../_mixins/use-form-item.js";
import ue from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { useThemeClass as ce } from "../../_mixins/use-css-vars-class.js";
import fe from "../styles/light.js";
import { createId as H } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { call as _ } from "../../_utils/vue/call.js";
import { defineComponent as me, computed as O, provide as he, h as L, Teleport as ge, Fragment as ve, nextTick as pe } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as x, toRef as d } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
var M = globalThis && globalThis.__awaiter || function(e, i, n, r) {
  function s(u) {
    return u instanceof n ? u : new n(function(m) {
      m(u);
    });
  }
  return new (n || (n = Promise))(function(u, m) {
    function p(o) {
      try {
        a(r.next(o));
      } catch (c) {
        m(c);
      }
    }
    function l(o) {
      try {
        a(r.throw(o));
      } catch (c) {
        m(c);
      }
    }
    function a(o) {
      o.done ? u(o.value) : s(o.value).then(p, l);
    }
    a((r = r.apply(e, i || [])).next());
  });
};
function Re(e, i, n) {
  const {
    doChange: r,
    xhrMap: s
  } = e;
  let u = 0;
  function m(l) {
    var a;
    let o = Object.assign({}, i, {
      status: "error",
      percentage: u
    });
    s.delete(i.id), o = U(((a = e.onError) === null || a === void 0 ? void 0 : a.call(e, {
      file: o,
      event: l
    })) || o), r(o, l);
  }
  function p(l) {
    var a;
    if (e.isErrorState) {
      if (e.isErrorState(n)) {
        m(l);
        return;
      }
    } else if (n.status < 200 || n.status >= 300) {
      m(l);
      return;
    }
    let o = Object.assign({}, i, {
      status: "finished",
      percentage: u
    });
    s.delete(i.id), o = U(((a = e.onFinish) === null || a === void 0 ? void 0 : a.call(e, {
      file: o,
      event: l
    })) || o), r(o, l);
  }
  return {
    handleXHRLoad: p,
    handleXHRError: m,
    handleXHRAbort(l) {
      const a = Object.assign({}, i, {
        status: "removed",
        file: null,
        percentage: u
      });
      s.delete(i.id), r(a, l);
    },
    handleXHRProgress(l) {
      const a = Object.assign({}, i, {
        status: "uploading"
      });
      if (l.lengthComputable) {
        const o = Math.ceil(l.loaded / l.total * 100);
        a.percentage = o, u = o;
      }
      r(a, l);
    }
  };
}
function ye(e) {
  const {
    inst: i,
    file: n,
    data: r,
    headers: s,
    withCredentials: u,
    action: m,
    customRequest: p
  } = e, {
    doChange: l
  } = e.inst;
  let a = 0;
  p({
    file: n,
    data: r,
    headers: s,
    withCredentials: u,
    action: m,
    onProgress(o) {
      const c = Object.assign({}, n, {
        status: "uploading"
      }), C = o.percent;
      c.percentage = C, a = C, l(c);
    },
    onFinish() {
      var o;
      let c = Object.assign({}, n, {
        status: "finished",
        percentage: a
      });
      c = U(((o = i.onFinish) === null || o === void 0 ? void 0 : o.call(i, {
        file: c
      })) || c), l(c);
    },
    onError() {
      var o;
      let c = Object.assign({}, n, {
        status: "error",
        percentage: a
      });
      c = U(((o = i.onError) === null || o === void 0 ? void 0 : o.call(i, {
        file: c
      })) || c), l(c);
    }
  });
}
function be(e, i, n) {
  const r = Re(e, i, n);
  n.onabort = r.handleXHRAbort, n.onerror = r.handleXHRError, n.onload = r.handleXHRLoad, n.upload && (n.upload.onprogress = r.handleXHRProgress);
}
function N(e, i) {
  return typeof e == "function" ? e({
    file: i
  }) : e || {};
}
function we(e, i, n) {
  const r = N(i, n);
  r && Object.keys(r).forEach((s) => {
    e.setRequestHeader(s, r[s]);
  });
}
function Ce(e, i, n) {
  const r = N(i, n);
  r && Object.keys(r).forEach((s) => {
    e.append(s, r[s]);
  });
}
function Fe(e, i, n, {
  method: r,
  action: s,
  withCredentials: u,
  responseType: m,
  headers: p,
  data: l
}) {
  const a = new XMLHttpRequest();
  a.responseType = m, e.xhrMap.set(n.id, a), a.withCredentials = u;
  const o = new FormData();
  if (Ce(o, l, n), n.file !== null && o.append(i, n.file), be(e, n, a), s !== void 0) {
    a.open(r.toUpperCase(), s), we(a, p, n), a.send(o);
    const c = Object.assign({}, n, {
      status: "uploading"
    });
    e.doChange(c);
  }
}
const Be = Object.assign(Object.assign({}, X.props), {
  name: {
    type: String,
    default: "file"
  },
  accept: String,
  action: String,
  customRequest: Function,
  directory: Boolean,
  directoryDnd: {
    type: Boolean,
    default: void 0
  },
  method: {
    type: String,
    default: "POST"
  },
  multiple: Boolean,
  showFileList: {
    type: Boolean,
    default: !0
  },
  data: [Object, Function],
  headers: [Object, Function],
  withCredentials: Boolean,
  responseType: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  onChange: Function,
  onRemove: Function,
  onFinish: Function,
  onError: Function,
  onRetry: Function,
  onBeforeUpload: Function,
  isErrorState: Function,
  /** currently not used */
  onDownload: Function,
  customDownload: Function,
  defaultUpload: {
    type: Boolean,
    default: !0
  },
  fileList: Array,
  "onUpdate:fileList": [Function, Array],
  onUpdateFileList: [Function, Array],
  fileListClass: String,
  fileListStyle: [String, Object],
  defaultFileList: {
    type: Array,
    default: () => []
  },
  showCancelButton: {
    type: Boolean,
    default: !0
  },
  showRemoveButton: {
    type: Boolean,
    default: !0
  },
  showDownloadButton: Boolean,
  showRetryButton: {
    type: Boolean,
    default: !0
  },
  showPreviewButton: {
    type: Boolean,
    default: !0
  },
  listType: {
    type: String,
    default: "text"
  },
  onPreview: Function,
  shouldUseThumbnailUrl: {
    type: Function,
    default: (e) => ne ? oe(e) : !1
  },
  createThumbnailUrl: Function,
  abstract: Boolean,
  max: Number,
  showTrigger: {
    type: Boolean,
    default: !0
  },
  imageGroupProps: Object,
  inputProps: Object,
  triggerClass: String,
  triggerStyle: [String, Object],
  renderIcon: Function
}), $e = me({
  name: "Upload",
  props: Be,
  setup(e) {
    e.abstract && e.listType === "image-card" && ae("upload", "when the list-type is image-card, abstract is not supported.");
    const {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: n
    } = se(e), r = X("Upload", "-upload", Y, fe, e, i), s = de(e), u = x(e.defaultFileList), m = d(e, "fileList"), p = x(null), l = {
      value: !1
    }, a = x(!1), o = /* @__PURE__ */ new Map(), c = ue(m, u), C = O(() => c.value.map(U)), A = O(() => {
      const {
        max: t
      } = e;
      return t !== void 0 ? C.value.length >= t : !1;
    });
    function P() {
      var t;
      (t = p.value) === null || t === void 0 || t.click();
    }
    function V(t) {
      const h = t.target;
      E(h.files ? Array.from(h.files).map((g) => ({
        file: g,
        entry: null,
        source: "input"
      })) : null, t), h.value = "";
    }
    function $(t) {
      const {
        "onUpdate:fileList": h,
        onUpdateFileList: g
      } = e;
      h && _(h, t), g && _(g, t), u.value = t;
    }
    const I = O(() => e.multiple || e.directory), S = (t, h, g = {
      append: !1,
      remove: !1
    }) => {
      const {
        append: F,
        remove: b
      } = g, R = Array.from(C.value), v = R.findIndex((f) => f.id === t.id);
      if (F || b || ~v) {
        F ? R.push(t) : b ? R.splice(v, 1) : R.splice(v, 1, t);
        const {
          onChange: f
        } = e;
        f && f({
          file: t,
          fileList: R,
          event: h
        }), $(R);
      } else
        process.env.NODE_ENV !== "production" && le("upload", "File has no corresponding id in current file list.");
    };
    function E(t, h) {
      if (!t || t.length === 0)
        return;
      const {
        onBeforeUpload: g
      } = e;
      t = I.value ? t : [t[0]];
      const {
        max: F,
        accept: b
      } = e;
      t = t.filter(({
        file: v,
        source: f
      }) => f === "dnd" && (b != null && b.trim()) ? re(v.name, v.type, b) : !0), F && (t = t.slice(0, F - C.value.length));
      const R = H();
      Promise.all(t.map((v) => M(this, [v], void 0, function* ({
        file: f,
        entry: B
      }) {
        var w;
        const T = {
          id: H(),
          batchId: R,
          name: f.name,
          status: "pending",
          percentage: 0,
          file: f,
          url: null,
          type: f.type,
          thumbnailUrl: null,
          fullPath: (w = B == null ? void 0 : B.fullPath) !== null && w !== void 0 ? w : `/${f.webkitRelativePath || f.name}`
        };
        return !g || (yield g({
          file: T,
          fileList: C.value
        })) !== !1 ? T : null;
      }))).then((v) => M(this, void 0, void 0, function* () {
        let f = Promise.resolve();
        v.forEach((B) => {
          f = f.then(pe).then(() => {
            B && S(B, h, {
              append: !0
            });
          });
        }), yield f;
      })).then(() => {
        e.defaultUpload && D();
      });
    }
    function D(t) {
      const {
        method: h,
        action: g,
        withCredentials: F,
        headers: b,
        data: R,
        name: v
      } = e, f = t !== void 0 ? C.value.filter((w) => w.id === t) : C.value, B = t !== void 0;
      f.forEach((w) => {
        const {
          status: T
        } = w;
        (T === "pending" || T === "error" && B) && (e.customRequest ? ye({
          inst: {
            doChange: S,
            xhrMap: o,
            onFinish: e.onFinish,
            onError: e.onError
          },
          file: w,
          action: g,
          withCredentials: F,
          headers: b,
          data: R,
          customRequest: e.customRequest
        }) : Fe({
          doChange: S,
          xhrMap: o,
          onFinish: e.onFinish,
          onError: e.onError,
          isErrorState: e.isErrorState
        }, v, w, {
          method: h,
          action: g,
          withCredentials: F,
          responseType: e.responseType,
          headers: b,
          data: R
        }));
      });
    }
    function k(t) {
      var h;
      if (t.thumbnailUrl)
        return t.thumbnailUrl;
      const {
        createThumbnailUrl: g
      } = e;
      return g ? (h = g(t.file, t)) !== null && h !== void 0 ? h : t.url || "" : t.url ? t.url : t.file ? ie(t.file) : "";
    }
    const j = O(() => {
      const {
        common: {
          cubicBezierEaseInOut: t
        },
        self: {
          draggerColor: h,
          draggerBorder: g,
          draggerBorderHover: F,
          itemColorHover: b,
          itemColorHoverError: R,
          itemTextColorError: v,
          itemTextColorSuccess: f,
          itemTextColor: B,
          itemIconColor: w,
          itemDisabledOpacity: T,
          lineHeight: q,
          borderRadius: G,
          fontSize: K,
          itemBorderImageCardError: J,
          itemBorderImageCard: Q
        }
      } = r.value;
      return {
        "--n-bezier": t,
        "--n-border-radius": G,
        "--n-dragger-border": g,
        "--n-dragger-border-hover": F,
        "--n-dragger-color": h,
        "--n-font-size": K,
        "--n-item-color-hover": b,
        "--n-item-color-hover-error": R,
        "--n-item-disabled-opacity": T,
        "--n-item-icon-color": w,
        "--n-item-text-color": B,
        "--n-item-text-color-error": v,
        "--n-item-text-color-success": f,
        "--n-line-height": q,
        "--n-item-border-image-card-error": J,
        "--n-item-border-image-card": Q
      };
    }), y = n ? ce("upload", void 0, j, e) : void 0;
    he(W, {
      mergedClsPrefixRef: i,
      mergedThemeRef: r,
      showCancelButtonRef: d(e, "showCancelButton"),
      showDownloadButtonRef: d(e, "showDownloadButton"),
      showRemoveButtonRef: d(e, "showRemoveButton"),
      showRetryButtonRef: d(e, "showRetryButton"),
      onRemoveRef: d(e, "onRemove"),
      onDownloadRef: d(e, "onDownload"),
      customDownloadRef: d(e, "customDownload"),
      mergedFileListRef: C,
      triggerClassRef: d(e, "triggerClass"),
      triggerStyleRef: d(e, "triggerStyle"),
      shouldUseThumbnailUrlRef: d(e, "shouldUseThumbnailUrl"),
      renderIconRef: d(e, "renderIcon"),
      xhrMap: o,
      submit: D,
      doChange: S,
      showPreviewButtonRef: d(e, "showPreviewButton"),
      onPreviewRef: d(e, "onPreview"),
      getFileThumbnailUrlResolver: k,
      listTypeRef: d(e, "listType"),
      dragOverRef: a,
      openOpenFileDialog: P,
      draggerInsideRef: l,
      handleFileAddition: E,
      mergedDisabledRef: s.mergedDisabledRef,
      maxReachedRef: A,
      fileListClassRef: d(e, "fileListClass"),
      fileListStyleRef: d(e, "fileListStyle"),
      abstractRef: d(e, "abstract"),
      acceptRef: d(e, "accept"),
      cssVarsRef: n ? void 0 : j,
      themeClassRef: y == null ? void 0 : y.themeClass,
      onRender: y == null ? void 0 : y.onRender,
      showTriggerRef: d(e, "showTrigger"),
      imageGroupPropsRef: d(e, "imageGroupProps"),
      mergedDirectoryDndRef: O(() => {
        var t;
        return (t = e.directoryDnd) !== null && t !== void 0 ? t : e.directory;
      }),
      onRetryRef: d(e, "onRetry")
    });
    const z = {
      clear: () => {
        u.value = [];
      },
      submit: D,
      openOpenFileDialog: P
    };
    return Object.assign({
      mergedClsPrefix: i,
      draggerInsideRef: l,
      inputElRef: p,
      mergedTheme: r,
      dragOver: a,
      mergedMultiple: I,
      cssVars: n ? void 0 : j,
      themeClass: y == null ? void 0 : y.themeClass,
      onRender: y == null ? void 0 : y.onRender,
      handleFileInputChange: V
    }, z);
  },
  render() {
    var e, i;
    const {
      draggerInsideRef: n,
      mergedClsPrefix: r,
      $slots: s,
      directory: u,
      onRender: m
    } = this;
    if (s.default && !this.abstract) {
      const l = s.default()[0];
      !((e = l == null ? void 0 : l.type) === null || e === void 0) && e[Z] && (n.value = !0);
    }
    const p = L("input", Object.assign({}, this.inputProps, {
      ref: "inputElRef",
      type: "file",
      class: `${r}-upload-file-input`,
      accept: this.accept,
      multiple: this.mergedMultiple,
      onChange: this.handleFileInputChange,
      // @ts-expect-error // seems vue-tsc will add the prop, so we can't use expect-error
      webkitdirectory: u || void 0,
      directory: u || void 0
    }));
    return this.abstract ? L(ve, null, (i = s.default) === null || i === void 0 ? void 0 : i.call(s), L(ge, {
      to: "body"
    }, p)) : (m == null || m(), L("div", {
      class: [`${r}-upload`, n.value && `${r}-upload--dragger-inside`, this.dragOver && `${r}-upload--drag-over`, this.themeClass],
      style: this.cssVars
    }, p, this.showTrigger && this.listType !== "image-card" && L(te, null, s), this.showFileList && L(ee, null, s)));
  }
});
export {
  $e as default,
  Be as uploadProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/Upload.js
// module id = 981
// module chunks = 67